import React from "react";
import "./tourButton.css";

const TourButton = ({ onClick }) => {
  return (
    <button
      className="sr-tour-btn"
      onClick={onClick}
      aria-label="Replay walkthrough tour"
      title="Page tour"
    >
      ?
    </button>
  );
};

export default TourButton;
